"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicencePriceUpdateBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var DrivingLicencePriceUpdateBanner = /** @class */ (function (_super) {
    __extends(DrivingLicencePriceUpdateBanner, _super);
    function DrivingLicencePriceUpdateBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DrivingLicencePriceUpdateBanner.prototype.render = function () {
        var interaction = this.props.interaction;
        var isAnnual = interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL;
        var premium = isAnnual ? interaction.factors.annualPremium : interaction.factors.monthlyPremium;
        var previousPremium = isAnnual ? interaction.uistate.temporaryAnnualPremium : interaction.uistate.temporaryMonthlyPremium;
        var premiumChangeLabel = premium > previousPremium ? "increased" : "decreased";
        return ((0, jsx_runtime_1.jsx)("div", { className: "banner banner-warn", children: (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "Price update" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Just so you know, your new price has ", premiumChangeLabel, " to ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountToDisplay)(premium) }), " due to the information on your driving licence that wasn't previously disclosed."] })] }) }) }));
    };
    return DrivingLicencePriceUpdateBanner;
}(React.Component));
exports.DrivingLicencePriceUpdateBanner = DrivingLicencePriceUpdateBanner;
//# sourceMappingURL=DrivingLicencePriceUpdateBanner.js.map